import { Card, CardContent } from "@material-ui/core";
import CardTitle from "@saleor/components/CardTitle";
import { FormChange } from "@saleor/hooks/useForm";
import React, { FC } from "react";
import { useIntl } from "react-intl";

import { useStyles } from "./styles";
import CouponTaggingCheckbox from "./subcomponents/Checkbox/Checkbox";

interface ICouponTaggingCardProps {
  isFeatured: boolean;
  isAppExclusive: boolean;
  isAppExclusiveHidden: boolean;
  onChange: FormChange;
  isEditableState?: boolean;
}

const CouponTaggingCard: FC<ICouponTaggingCardProps> = ({
  isFeatured,
  isAppExclusive,
  isAppExclusiveHidden,
  onChange,
  isEditableState = true
}) => {
  const intl = useIntl();
  const classes = useStyles({});
  return (
    <Card className={classes.cardStyle}>
      <CardTitle
        className={classes.cardTitle}
        title={intl.formatMessage({
          defaultMessage: "Coupon Tagging Card",
          description: "Coupon Tagging Card"
        })}
      />
      <CardContent>
        <CouponTaggingCheckbox
          isChecked={isFeatured}
          onChange={value =>
            onChange({
              target: {
                name: "isFeatured",
                value
              }
            })
          }
          labelText="Featured"
          infoTooltipText="Check this if you want to highlight this coupon for better visibility."
          isDisabled={!isEditableState}
        />
        {!isAppExclusiveHidden && (
          <CouponTaggingCheckbox
            isChecked={isAppExclusive}
            onChange={value =>
              onChange({
                target: {
                  name: "isAppExclusive",
                  value
                }
              })
            }
            labelText="App Exclusive"
            infoTooltipText="Check this to mark the coupon as available only in the app."
            isDisabled={!isEditableState}
          />
        )}
      </CardContent>
    </Card>
  );
};

export default CouponTaggingCard;
